import React, { Component } from 'react';
// import * as pt from 'prop-types';
import moment from 'moment';
// import Switch from 'react-bootstrap-switch';
import MdCallMade from 'react-icons/lib/md/call-made';
import _ from 'underscore';

import Modal from '../../../../../common/components/Modal';
import TranscriptEditModal from './TranscriptEditModal';
import RestrictedComponent from '../../../../../lib/components/form/RestrictedComponent';
import schema from '../../../../../routes/permissions/schema';

// "vbJobID": "d748c4b3-587a-4ce2-b19b-dc9264f65e6c",
// "clientID": "1000000001",
// "eventID": "1000000001_2017101000",
// "status": "finished",
// "billableMinutes": "2",
// "useAsCaptions": false,
// "useText": false,
// "webvtt": "https://invintus-client-transcripts.s3.amazonaws.com/1000000001/2017101000.vtt",
// "text": "https://invintus-client-transcripts.s3.amazonaws.com/1000000001/2017101000.txt",
// "datemodified": "2017-10-12 20:14:05"
class TranscriptManager extends Component {
    constructor (props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.toggleEditModal = this.toggleEditModal.bind(this);
        this.toggleCreateModal = this.toggleCreateModal.bind(this);
        this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
        this.handleDeleteTranscript = this.handleDeleteTranscript.bind(this);
        this.handleCreateTranscript = this.handleCreateTranscript.bind(this);
        this.handleSetAsCaptionFile = this.handleSetAsCaptionFile.bind(this);
        this.openFile = this.openFile.bind(this);
        this.renderDeleteModal = this.renderDeleteModal.bind(this);
    }

    componentWillUnmount () {
        // Reset the "edit" state so when different
        // events are navigated to the edits for this event
        // do not persist
        // https://zube.io/tvwit/invintus-platform/c/1769
        this.props.actions.transcript.toggleModal({
            editModal: false
        })
    }

    toggleModal (type) {
        const updates = {};
        updates[type] = !this.props[type];
        this.props.actions.transcript.toggleModal(updates);
    }

    toggleEditModal () {
        this.toggleModal('editModal');
    }

    toggleDeleteModal () {
        this.toggleModal('deleteModal');
    }

    toggleCreateModal () {
        this.toggleModal('createModal');
    }

    openFile (type) {
        // @TODO
        console.log('type', type);
    }

    handleDeleteTranscript (ev) {
        ev && ev.preventDefault();
        this.props.actions.transcript.delete({
            eventID: this.props.event.eventID
        });
    }

    handleCreateTranscript (ev) {
        ev && ev.preventDefault();
        this.props.actions.transcript.create({
            eventID: this.props.event.eventID
        });
    }

    // @TODO - save/reset button
    handleSetAsCaptionFile (event) {
        this.props.actions.transcript.setUseAsCaptions({
            UseAsCaption: event.target.checked,
            eventID: this.props.event.eventID
        });
    }

    render () {
        const { event, transcript } = this.props;
        let title, actions = [];

        var captionsResolving = this.props.requests.isResolving &&
            Boolean(_(this.props.requests.resolving).findWhere({
                type: 'setUseAsCaptions'
            }));

        if (transcript.data && (transcript.data.status === 'finished')) {
            const formattedDate = moment(
                transcript.data.datemodified, 'YYYY-MM-DD HH:mm:ss'
            ).format('MMMM D YYYY, h:mma');

            title = (<h4>
                Transcript Processed <small>{formattedDate}</small>
            </h4>);

            actions = [{
                component: captionsResolving ?
                    [<i className="fa fa-circle-notch fa-spin fa-fw" key={0}>
                    </i>, <span className="sr-only" key={1}>Loading...</span>,
                    <span style={{fontWeight: 'bold'}} key={2}> Use as Event Caption</span>] :

                    <label>
                        <RestrictedComponent permissionCheck={schema.EVENT_TAB_TRANSCRIPTION.USE_AS_DEFAULT}>
                            <input
                                type="checkbox"
                                onChange={this.handleSetAsCaptionFile}
                                checked={transcript.data ?
                                    ((transcript.data.useAsCaptions === "1") ? true : false) : false
                                }
                            /> Use as Event Caption
                        </RestrictedComponent>
                    </label>
            }, {
                label: "Edit Transcript",
                action: this.toggleEditModal
            }, {
                color: 'danger',
                label: "Delete Transcript",
                action: this.toggleDeleteModal
            }];
        } else if (!transcript.data) {
            actions = [{
                color: 'success',
                disabled: event.eventStatus != 'published',
                label: 'Generate Transcript',
                action: this.toggleCreateModal
            }];
        }

        return (<div>
            <header>{title}</header>

            {(transcript.data || {}).status === 'finished' ?
                <a href={transcript.data.webvtt} target="_blank">
                    <i className="fa fa-download" aria-hidden="true" /> Download vtt
                </a> :
                null
            }

            {title ? <hr/> : null}

            <div style={{ textAlign: 'right' }}>
                {actions.map(function (el, i) {
                    const disabled = el.hasOwnProperty('disabled') &&
                        el.disabled === true;

                    return !el.hasOwnProperty('component') ? (<button
                        key={i}
                        style={{ marginLeft: '.5rem' }}
                        disabled={disabled}
                        className={'btn btn-' + (el.color ? el.color : 'default')}
                        onClick={el.action}
                    >
                        {!disabled ? el.label : "Event Must Be Published"}
                    </button>) : (<span key={i}>
                        {el.component}
                    </span>);
                }, this)}
            </div>

            {this.props.editModal ?
                <TranscriptEditModal
                    event={this.props.event}
                    actions={this.props.actions}
                    requests={this.props.requests}
                    transcript={this.props.transcript}
                    cancelModal={this.toggleModal.bind(null, 'editModal')}
                    eventID={this.props.event.eventID}
                /> :
                null}

            {this.props.deleteModal ? this.renderDeleteModal() : null}
            {this.props.createModal ? this.renderCreateModal() : null}
        </div>);
    }

    renderCreateModal () {
        var createResolving = this.props.requests.isResolving &&
            Boolean(_(this.props.requests.resolving).findWhere({
                type: 'create'
            }));

        var icon = createResolving ?
            <i className="fa fa-circle-notch fa-spin fa-fw" /> :
            <MdCallMade/>;

        return (<Modal
            saveAction={<RestrictedComponent permissionCheck={schema.EVENT_TAB_TRANSCRIPTION.UPDATE}>
                <button className="btn btn-success"
                    onClick={this.handleCreateTranscript}
                    disabled={createResolving}
                >
                    {icon} Generate Transcript
                </button>
            </RestrictedComponent>}
            cancelModal={this.toggleCreateModal}
        >

            <Modal.Header>Create Transcript</Modal.Header>

            <Modal.Body>
                <div className="alert alert-info">
                    <h4>This Will Incur Cost</h4>
                </div>
            </Modal.Body>

            <Modal.Footer></Modal.Footer>
        </Modal>);
    }

    renderDeleteModal () {
        var deleteResolving = this.props.requests.isResolving &&
            Boolean(_(this.props.requests.resolving).findWhere({
                type: 'delete'
            }));

        var icon = deleteResolving ?
            <i className="fa fa-circle-notch fa-spin fa-fw" /> :
            <i className="fa fa-trash-can" />;

        return (<Modal
            saveAction={<RestrictedComponent permissionCheck={schema.EVENT_TAB_TRANSCRIPTION.DELETE}>
                <button className="btn btn-danger"
                    onClick={this.handleDeleteTranscript}
                    disabled={deleteResolving}
                >
                    {icon} Delete
                </button>
            </RestrictedComponent>}
            cancelModal={this.toggleDeleteModal}
        >

            <Modal.Header>Delete Transcript?</Modal.Header>

            <Modal.Body>
                <div className="alert alert-danger">
                    <h4>This Cannot be Undone!</h4>
                </div>
            </Modal.Body>

            <Modal.Footer></Modal.Footer>
        </Modal>);
    }
}

TranscriptManager.propTypes = {};

export default TranscriptManager;
